import { useMemo } from "react";
import { MultiSelect, type Option } from "@/components/ui/multi-select";
import { useRoles } from "@/lib/api/roles";

interface RoleMultiselectProps {
  value: string[];
  onChange: (roleIds: string[]) => void;
  disabled?: boolean;
}

export function RoleMultiselect({
  value,
  onChange,
  disabled,
}: RoleMultiselectProps) {
  const { data: roles, isLoading } = useRoles();

  const options = useMemo<Option[]>(
    () =>
      (roles ?? []).map((role) => ({
        value: role.id,
        label: role.name,
      })),
    [roles],
  );

  const selectedOptions = useMemo(
    () => options.filter((o) => value.includes(o.value)),
    [options, value],
  );

  return (
    <MultiSelect
      options={options}
      defaultValue={selectedOptions}
      placeholder={isLoading ? "Loading roles…" : "Select roles…"}
      disabled={disabled || isLoading}
      onChange={(selected) => onChange(selected.map((o) => o.value))}
    />
  );
}
